import React, { useState } from 'react';

function TextAreaForm({ onSubmit }) {
    const [text, setText] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(text);
        }
        setText(''); // Clear the textarea after submission
    };

    return (
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
            <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Enter domains, one per line"
                className="border border-gray-300 rounded-lg p-2 resize-none overflow-auto"
                rows="5"
            />
            <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
            >
                Add
            </button>
        </form>
    );
}

export default TextAreaForm;
